export default "/shUSDT.153083ba11548ccf67866d35e8d5370b.svg";